/* eslint-disable react-hooks/exhaustive-deps */
import { MutableRefObject, useEffect, useState } from "react"
import { getLandingContainer } from "../views/utils/getLandingContainer"
import { isInViewport } from "./useInViewport"


export function useAnimated ( ref: MutableRefObject<null>, delay: number | string = "" ): boolean { 
    const [container, setContainer]     = useState<Element>( getLandingContainer() )
    const [inViewport, setIsInViewport] = useState<boolean>( false ) 
    const onscrollHandler = () => {
        try { 
                const element:Element | null = ref.current   
                if(!!element &&  isInViewport( element ) && !inViewport )  {
                    (element as Element).classList.add( `animated${delay}` ); 
                    setIsInViewport(true)
                } 
        } 
        catch (e) {            
            console.log(e)            
        }
    }

    useEffect(() => {
        setContainer( getLandingContainer() ) 
    }, [delay ])

    useEffect(() => {  
        const element:Element | null = ref.current 
        if( !!element && (element as Element).classList.contains( "animate" ) && !!container) {
            container.addEventListener("scroll", onscrollHandler) 
            return () => { 
                container.removeEventListener("scroll", onscrollHandler)
            }
        }
    }, [ ref, container ]) 

    //TODO setTimeout -> первая карточка (Card) "застряёт", если секция появляется в области видимости с загрузкой страницы
    setTimeout(() => {
        onscrollHandler()
    }, 1 )
    
    return inViewport
}
